
















import { Component, Vue } from 'vue-property-decorator';
import TrackChangeCompilations from './TrackChangeCompilations.vue';
import PlaylistFormModal from './PlaylistFormModal.vue';
import TracksSelectModal from './TracksSelectModal.vue';
import CompilationSelectModal from './CompilationSelectModal.vue';
import CompilationsSelectModal from './CompilationsSelectModal.vue';
import PlaylistsSelectModal from './PlaylistsSelectModal.vue';
import TrackTagsSelectModal from './TrackTagsSelectModal.vue';
import TagDeleteModal from './TagDeleteModal.vue';
import TrackShareCreateModal from './TrackShareCreateModal.vue';

@Component({
  components: {
    TrackChangeCompilations,
    PlaylistFormModal,
    TracksSelectModal,
    CompilationSelectModal,
    CompilationsSelectModal,
    PlaylistsSelectModal,
    TrackTagsSelectModal,
    TagDeleteModal,
    TrackShareCreateModal
  }
})
export default class extends Vue {}
